// See tailwind-workspace-preset.js for eViolin colour codes.
export enum EViolinStatus {
  ACTIVE = 'Active',
  AVAILABLE = 'Available',
  CHARGING = 'Charging',
  ERROR = 'Error',
  FULLY_CHARGED = 'FullyCharged',
  INACTIVE = 'Inactive'
}

// Unfortunately this duplication is needed for components that
// are initialized by JS code and not HTML. These correspond with
// the '500' colours in the workspace presets.
export const EViolinColorCodes: { [key: string]: string } = {
  [EViolinStatus.ACTIVE]: '#FF5000',
  [EViolinStatus.AVAILABLE]: '#2E866E',
  [EViolinStatus.CHARGING]: '#005BCE',
  [EViolinStatus.ERROR]: '#EC3B3B',
  [EViolinStatus.FULLY_CHARGED]: '#2CBB28',
  [EViolinStatus.INACTIVE]: '#848484'
};
